<script lang="ts" setup>
import FooterSkeleton from '@components/ui/footer/FooterSkeleton.vue'
import FooterUserCard from '@components/ui/footer/FooterUserCard.vue'
import HeaderCentered from '@components/ui/HeaderCentered.vue'
</script>

<template>
  <main class="flex flex-col">
    <HeaderCentered />
    <div class="flex-1 p-vw-32 flex flex-row gap-vw-32">
      <div class="h-full w-full overflow-y-auto pb-vh-64 max-h-[74.11vh]">
        <slot></slot>
      </div>
    </div>
    <FooterSkeleton>
      <template #identification>
        <div class="w-[calc(312*var(--vw))] h-full p-vh-32 pb-0 min-h-[calc(216*var(--vh))]">
          <FooterUserCard />
        </div>
      </template>
    </FooterSkeleton>
  </main>
</template>
